/**
 * [ui1006, paczka PROC, projekt 4.4] KROKI KARTY PROCEDURY — kod „następnego kroku” Z SERWERA (`PolitykiEtapy.Kroki`) → etap
 * i część karty, w której ten krok się wykonuje. Jedno miejsce dla karty procedury, źródeł startu i tabeli procedur.
 *
 * Serwer liczy etap, „na kogo czeka” i następny krok (pola `etap`, `etapNumer`, `czekaNa`, `nastepnyKrok` wiersza i szczegółów);
 * karta niczego nie zgaduje — tylko tłumaczy kod kroku na miejsce, gdzie stoi jego przycisk. Krok „czekamy_na_glos” i „brak”
 * nie mają miejsca wykonania (nic do zrobienia poza czekaniem).
 */
export const CZESC_KROKU = Object.freeze({
    dokoncz_tresc: { etap: 1, czesc: "tresc", przejscie: "treści" },
    wyslij_do_zatwierdzenia: { etap: 1, czesc: "wyslij", przejscie: "wysłania do zatwierdzenia" },
    popraw_tresc: { etap: 1, czesc: "wersje", przejscie: "wersji" },
    wyslij_do_recenzenta: { etap: 2, czesc: "recenzja", przejscie: "recenzji" },
    wyslij_do_zarzadu: { etap: 2, czesc: "glosowanie", przejscie: "głosowania zarządu" },
    czekamy_na_glos: { etap: 2, czesc: "glosowanie", przejscie: "głosowania zarządu", tylkoPodglad: true },
    opublikuj: { etap: 3, czesc: "publikacja", przejscie: "publikacji" },
    zobacz_potwierdzenia: { etap: 3, czesc: "potwierdzenia", przejscie: "potwierdzeń", tylkoPodglad: true },
    zrob_przeglad: { etap: 4, czesc: "przeglady", przejscie: "przeglądu treści" },
    zapisz_wynik_kontroli: { etap: 4, czesc: "kontrole", przejscie: "kontroli" },
});

/** Kroki, które wykonuje redakcja dokumentu — lustro `PolitykiEtapy.Kroki.Redakcyjne` (serwer). */
export const KROKI_REDAKCJI = Object.freeze([
    "dokoncz_tresc", "wyslij_do_zatwierdzenia", "popraw_tresc", "wyslij_do_recenzenta", "wyslij_do_zarzadu", "opublikuj", "zrob_przeglad", "zapisz_wynik_kontroli",
]);

/** Pierwsza część każdego etapu — karta otwarta z `?etap=N` bez `czesc` staje na niej. */
export const PIERWSZA_CZESC_ETAPU = Object.freeze({ 1: "tresc", 2: "recenzja", 3: "publikacja", 4: "przeglady", dane: "opis" });

/** Etap (`1`–`4` albo `dane`) części karty. */
export const ETAP_CZESCI = Object.freeze({
    tresc: "1", pliki: "1", wersje: "1", wyslij: "1",
    recenzja: "2", glosowanie: "2", papier: "2",
    publikacja: "3", czytelnicy: "3", adresaci: "3", potwierdzenia: "3",
    przeglady: "4", kontrole: "4", wycofanie: "4",
    opis: "dane", wyjatki: "dane", historia: "dane", audytor: "dane",
});

/** Etykiety części karty — te same słowa co w rejestrze obszarów (2.8). */
export const ETYKIETY_CZESCI = Object.freeze({
    tresc: "Treść", pliki: "Pliki i materiały", wersje: "Wersje", wyslij: "Wyślij do zatwierdzenia",
    recenzja: "Recenzja", glosowanie: "Głosowanie zarządu", papier: "Papier i historia głosowań",
    publikacja: "Publikacja", czytelnicy: "Kto może czytać", adresaci: "Kto musi potwierdzić", potwierdzenia: "Potwierdzenia",
    przeglady: "Przeglądy treści", kontrole: "Kontrole", wycofanie: "Wycofanie",
    opis: "Opis procedury", wyjatki: "Wyjątki od ustawień", historia: "Historia", audytor: "Dla audytora",
});

/** Miejsce kroku z serwera: `{ etap, czesc, przejscie, tylkoPodglad }` albo `null` (brak kroku / nic do zrobienia). */
export const miejsceKroku = (krok) => {
    const kod = krok && typeof krok === "object" ? krok.kod : krok;
    return (kod && CZESC_KROKU[kod]) || null;
};

/** Część docelowa dla adresu `?etap=N(&czesc=X)`: część z adresu, gdy należy do etapu; inaczej pierwsza część etapu. */
export const czescZAdresu = (etap, czesc) => {
    const e = String(etap || "");
    if (czesc && ETAP_CZESCI[czesc] && (!e || ETAP_CZESCI[czesc] === e)) return czesc;
    return PIERWSZA_CZESC_ETAPU[e] || null;
};
